import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class Content extends Component {
	render() {
		const { children } = this.props;
		return <div className="inbox-layout-content">{children}</div>;
	}
}
Content.propTypes = {
	children: PropTypes.node
};

export default Content;
